import { gql, useQuery } from '@apollo/client';

import type { GetDealsWithRemittances } from './__generated__/getDealsWithRemittances_gql';
export const GET_DEALS_WITH_REMITTANCES = gql`
  query GetDealsWithRemittances {
    getDealsWithRemittances {
      id
      listing {
        id
        name
      }
    }
  }
`;

export function useDealsWithRemittances() {
  return useQuery<GetDealsWithRemittances>(GET_DEALS_WITH_REMITTANCES);
}
